import { useMsal } from '@azure/msal-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { notification } from 'antd';

import { SystemApiClient } from '../../../providers/api-provider';
import {
	initIsAdmin,
	initSalesAgent,
} from '../../../slices/System/systemSlice';

export const useLogin = () => {
	const { instance } = useMsal();

	const dispatch = useDispatch();

	const [salesAgent, setSalesAgent] = useState<number>();
	const [isAdmin, setIsAdmin] = useState<boolean>();
	const [salesAgentLoading, setSalesAgentLoading] = useState<boolean>(false);

	const handleSalesAgent = async () => {
		setSalesAgentLoading(true);

		const clientApi = await SystemApiClient(instance);

		clientApi
			.authenticate()
			.then((response) => {
				setSalesAgent(response.data.userId);
				setIsAdmin(response.data.isAdmin);
				dispatch(initSalesAgent(response.data.userId));
				dispatch(initIsAdmin(response.data.isAdmin));
			})
			.catch((reason) => {
				notification.error({
					message: 'Unable to login!',
					description: 'Unable to retrieve sales agent from identity claims.',
					duration: 2,
				});
			})
			.finally(() => {
				setSalesAgentLoading(false);
			});
	};

	return {
		handleSalesAgent,
		salesAgent,
		salesAgentLoading,
		isAdmin,
	};
};
